export type TokenIcon = {
  token: string;
  icon: string;
};

export interface TokenIconProvider {
  fetch(): Promise<TokenIcon[]>;
}
